<template>
  <div
    class="flex flex-wrap gap-2 py-4 md:py-0 w-full justify-center max-h-62 overflow-y-auto md:max-h-none"
  >
    <BaseButton
      v-for="sc in filteredSpecialCategories"
      @click="() => handleClick(sc.name)"
      :key="sc.id"
      color="muted"
      class="px-3 py-1 max-w-full min-w-0"
      :class="[
        {
          '!border-primary': router.currentRoute.value.query.special_category === sc.name,
        },
      ]"
      ><span class="block max-w-[400px] overflow-hidden text-ellipsis whitespace-nowrap">{{ sc.name }}</span></BaseButton
    >
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';

  import BaseButton from '@/components/ui/BaseButton.vue';
  import { useGeneralStore } from '@/stores/general';

  const generalStore = useGeneralStore();
  const events = computed(() => generalStore.events());
  const specialCategories = computed(() => generalStore.special_categories());

  const filteredSpecialCategories = computed(() => {
    return specialCategories.value
      .filter(sc =>
        events.value.some(event => event.special_categories?.includes(sc.id))
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  });

  const router = useRouter();
  const emit = defineEmits(['onChange']);

  const handleClick = (specialCategory: string) => {
    const currentQuery = { ...router.currentRoute.value.query };
    const newQuery = { special_category: undefined as string | undefined };
    if (currentQuery.special_category !== specialCategory) {
      newQuery.special_category = specialCategory;
    }
    router.push({
      path: '/',
      query: newQuery,
    });

    emit('onChange');
  };
</script>
